import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    reasonsTitle: translate({ id: 'setup.reasonsForNotCompletedOrders.view.reasonsTitle' }),
    reasonsSubtitle: translate({ id: 'setup.reasonsForNotCompletedOrders.view.reasonsSubtitle' }),
  }))

  return api
}
